/**
 * Centralised application identity.
 *
 * The production domain is never hard-coded at a call site: everything that
 * prints, links to or labels the app reads it from here, so a deployment to a
 * different host only changes the environment.
 */

export const APP_NAME = process.env.REACT_APP_NAME || "Foliox";
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN || "foliox.sbs";
export const APP_URL = process.env.REACT_APP_URL || `https://${APP_DOMAIN}`;
export const APP_VERSION = process.env.REACT_APP_VERSION || "1.0.0";

/**
 * Printed on every generated document. Supplements - never replaces - the
 * specimen disclaimer that marks the output as fictional.
 */
export const APP_TAGLINE = "Generated for fictional/test and demonstration purposes.";
